export default "__VITE_ASSET__DcYmaruW__"